import React, { useEffect } from 'react';
import styles from '@/styles/ContactInformationComponent.module.scss';
import { getCTAS, getConditionalStatusWithPartnerStatus, URL } from '@/utils';
import { useAppContext } from '@/components';
import { PEIHeadLine, PEISectionFooter, PEIScalableTable, isBrandToSkip } from '@/common';

const { basePEIURL } = URL;
type FundCommitmentsComponent = {
  institutionID: string;
  institutionName: string;
  partnerStatus: string;
  fundCommitments: any;
  fundCommitmentsCount: any;
  userType: string;
};

export const FundCommitmentsComponent = ({
  institutionName,
  institutionID,
  partnerStatus,
  fundCommitments,
  fundCommitmentsCount,
  userType,
}: FundCommitmentsComponent) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'fund-commitment',
        value: fundCommitments.length > 0,
      },
    });
  }, [dispatch, fundCommitments]);

  const checkFundCommitment = getConditionalStatusWithPartnerStatus(
    'fund-commitment',
    partnerStatus
  );

  if (fundCommitmentsCount === 0) return <></>;

  const allData = getCTAS(userType, institutionName, institutionID);

  const fundCommitmentComponentData: {
    ctaHeading: string;
    LP: string;
    'LP/GP': string;
  } = allData['FundCommitmentComponent'];

  const ctas = {
    ctaButton: '',
  };

  switch (partnerStatus) {
    case 'LP':
      ctas.ctaButton = fundCommitmentComponentData.LP;
      break;
    case 'LP/GP':
      ctas.ctaButton = fundCommitmentComponentData['LP/GP'];
      break;
  }

  const data = fundCommitments.map((fund: any) => {
    return [
      {
        text: fund.fund,
        link:
          !isBrandToSkip && fund.id
            ? `${basePEIURL}/database/fund-profile/id/${fund.id}/${fund.fund}/fund-overview/`
            : null,
      },
      { text: fund.manager, icon: 'lock' },
      { text: fund.commitmentDate },
      { text: fund.commitmentSize, icon: fund.commitmentSize.includes('---') ? 'lock' : '' },
    ];
  });

  return (
    <React.Fragment>
      {checkFundCommitment ? (
        <article className={styles.container} id='fund-commitments'>
          <main className={styles['container-body']}>
            <PEIHeadLine text={`${institutionName} fund commitments`} />
            <PEIScalableTable
              title='Known fund commitments'
              count={fundCommitmentsCount}
              data={data}
              headers={['Fund', 'Manager', 'Commitment date', 'Commitment size']}
              start={fundCommitments.length}
              end={fundCommitmentsCount}
              institutionName={institutionName}
              componentName='fund commitments'
            />
          </main>
          <PEISectionFooter
            textToShow={fundCommitmentComponentData.ctaHeading}
            link={ctas.ctaButton}
          />
        </article>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};
